module.exports = __webpack_public_path__ + "img/test.416af71b.png";